import { Pipe, PipeTransform } from '@angular/core';
import { isNumeric } from '@cumlaude/shared-utils';
import { formatDecimal } from './extended-decimal.pipe';

/**
 * Geeft grote aantallen compact weer: 446 → `446`, 1000 → `1,0k`, 27489 → `27,5k`, 1234567 → `1,2M`.
 * Bedoeld voor getallen die je scant in plaats van narekent, zoals tokenaantallen; zet het exacte
 * getal in een `title` waar dat wél moet kunnen.
 *
 * Angular heeft hier niets voor: `DecimalPipe`/`formatNumber` doen geen compacte notatie, en
 * `Intl.NumberFormat` met `notation: 'compact'` geeft voor `nl-NL` een hoofdletter `K` en `mln.` in
 * plaats van `M` (en met `en-US` een decimale punt).
 *
 * Vast één decimaal boven de duizend, dus `24,0k` en niet `24k`: dat houdt getallen die op één regel
 * naast elkaar staan visueel gelijk lang. De classificatie gebeurt vóór het afronden, dus 999.999
 * wordt `1.000,0k` en niet `1,0M` — bij de aantallen waarvoor dit bedoeld is niet de moeite waard om
 * op te lossen.
 */
@Pipe({
	name: 'compactNumber',
})
export class CompactNumberPipe implements PipeTransform {
	transform(value: number | null | undefined): string {
		return formatCompact(value);
	}
}

export function formatCompact(value: number | string | null | undefined): string {
	if (!isNumeric(value)) return '';

	const number = Number(value);
	const absolute = Math.abs(number);

	if (absolute >= 1_000_000) return formatDecimal(number / 1_000_000, '1.1-1') + 'M';
	if (absolute >= 1_000) return formatDecimal(number / 1_000, '1.1-1') + 'k';
	return formatDecimal(number, '1.0-0');
}
